export default {
    namespaced: true,
    state: {
        isClient: true, //是不是客户端
        Authorization: sessionStorage.getItem('Authorization') ? sessionStorage.getItem('Authorization') : '',
        userData: null,
        showModelPage: true,//是否显示关于模板的功能   大赛需要隐藏掉
        AIswitch: false,//ai机器人是否静态
        SkinMode: "light",//皮肤模式
        FirstMarking: true,//是否首次进入平台标记
        sysIdentity: "dataAsset"
    },
    mutations: {
        changeLogin(state, user) {
            state.Authorization = user.Authorization;
            sessionStorage.setItem('Authorization', user.Authorization);
        },
        setUserData(state, data) {
            state.userData = data
        },
        setAIswitch(state, data) {
            state.AIswitch = data
        },
        setSkinMode(state, data) {
            state.SkinMode = data
            window.document.documentElement.setAttribute('data-theme', data)
        },
        setFirstMark(state, data) {
            state.FirstMarking = data
        },
        setIsClient(state, data) {
            state.isClient = data
        },
        setSysIdentity(state, data) {
            state.sysIdentity = data
        },
    },
    actions: {

    },
}



// WEBPACK FOOTER //
// ./src/store/system.js